import { useTranslation } from "react-i18next";
import { Flex } from "antd";

import { Input } from "@av/components/atoms/input/Input";
import { Select } from "@av/components/atoms/Select";
import { useFetchSecurityGroups } from "../../../../../services/admin-settings/security-groups";

type FiltersProps = {
  searchText: string;
  onSearchTextChange: (v: string) => void;
  selectedSecurityGroups: string[] | null;
  onSelectedSecurityGroupsChange: (v: string[] | null) => void;
};

export function UserFilters(props: FiltersProps) {
  const { searchText, onSearchTextChange, selectedSecurityGroups, onSelectedSecurityGroupsChange } =
    props;
  const { t } = useTranslation();
  const { data: securityGroups } = useFetchSecurityGroups("hr");

  return (
    <Flex justify="space-between">
      <Flex justify="flex-start" align="center" gap="large">
        <Input.Search
          size="large"
          style={{ width: "400px" }}
          placeholder={t("platform.adminSettings.searchUsers")}
          value={searchText}
          onChange={(e) => onSearchTextChange(e.target.value)}
          onKeyDown={(e) => e.key === "Escape" && onSearchTextChange("")}
          testIdPrefix="search-box"
        />

        <Flex gap="middle">
          <Select
            showSearch
            optionFilterProp="label"
            testIdPrefix="view-all-security-groups"
            style={{ minWidth: "11em" }}
            mode="multiple"
            value={selectedSecurityGroups}
            options={securityGroups}
            placeholder={t("platform.adminSettings.filters_bySecurityGroup")}
            onChange={onSelectedSecurityGroupsChange}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
